import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueWorkflowSchemesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-workflows-schemes-view',
	path: '/secure/admin/ViewWorkflowSchemes.jspa',
};
